import { b, a } from './chunk-FUQLNXR2.mjs';
import { jsx } from 'react/jsx-runtime';

var t=l=>jsx("svg",b(a({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 448 512",fill:"currentColor"},l),{children:jsx("path",{d:"M0 80L0 229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7L48 32C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"})})),n=t;

export { n as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-DJMZOZA2.mjs.map